import { captureException } from '@sentry/react';

import { apiClient, ApiClientMode } from '@/services/http';

interface MetascraperResponse {
    author?: string;
    date?: string;
    description?: string;
    image?: string;
    logo?: string;
    publisher?: string;
    title?: string;
    url?: string;
}

interface OpenGraphMetadata {
    openGraph?: {
        author?: string;
        date?: string;
        description?: string;
        image?: {
            url?: string;
        };
        logo?: {
            url?: string;
        };
        publisher?: string;
        title?: string;
        url?: string;
    };
}

export const fetchMetadata = async (
    url: string,
    options?: { mode?: Extract<ApiClientMode, 'authorized' | 'unauthorized'> },
): Promise<OpenGraphMetadata | null> => {
    try {
        const mode = options?.mode ?? 'authorized';
        const metadata = await apiClient.post<MetascraperResponse, { url: string }>(
            mode === 'unauthorized' ? '/public/services/metascraper' : '/api/services/metascraper',
            { url },
            { mode, suppressErrorCapture: true },
        );

        return {
            openGraph: {
                author: metadata.author,
                date: metadata.date,
                description: metadata.description,
                image: metadata.image ? { url: metadata.image } : undefined,
                logo: metadata.logo ? { url: metadata.logo } : undefined,
                publisher: metadata.publisher,
                title: metadata.title,
                url: metadata.url,
            },
        };
    } catch (error) {
        captureException(error);

        return null;
    }
};
